/* Genera 3 tipos de menus: Se recibe un arreglo con el nombre de los menus */

//*react- recursos
  import { useState } from "react";
//*componentes-utiles
  import GeneraMenu from "../../../componentes/generaMenu/GeneraMenu";

//*datos
  import menu from "../../../datos/json/menu.json";

//*archivos & componentes (imagenes y elementos necesarios para la rutina)
  import PaginaMenu1 from "./PaginaMenu1";
  import PaginaMenu2 from "./PaginaMenu2";
  import PaginaMenu3 from "./PaginaMenu3";
  import PaginaMenu4 from "./PaginaMenu4";
  import PaginaMenu5 from "./PaginaMenu5";

//*componente
  export default function Ejemplo() {
  
    //*useState
      const [paginaActiva, setPaginaActiva] = useState("1");
    //*vista
      return (
        <div className="container container-Vista" >
          <h1>Ejemplo de generación de un menu 2 tipos se manda parámetro {1} o {2}</h1>

          <div className="container-Componente" >
            {/* 2 tipos de menu, tipo 1 se acomoda en donde se mande llamar, tipo 2 arriba mas un mensaje */}
            <GeneraMenu menu={menu} tipo={1} msjTipo2={'Encabezado'}/>
          </div>


          <div> 
                  { paginaActiva==="1" ? <PaginaMenu1/> : null } 
                  { paginaActiva==="2" ? <PaginaMenu2/> : null } 
                  { paginaActiva==="3" ? <PaginaMenu3/> : null } 
                  { paginaActiva==="4" ? <PaginaMenu4/> : null } 
                  { paginaActiva==="5" ? <PaginaMenu5/> : null } 
          </div>
          <br></br>
        </div>
      );
  }
